/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
// These IDs represent the specific modules that are accessible on the app
export const allowedModuleIdsApp = [1, 5, 4, 3, 2, 17, 20, 46, 53, 92];
// These IDs represent the specific modules that are accessible on the web platform
export const allowedModuleIdsWeb = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 23,
    26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
    46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66,
    67, 68, 69, 70, 71, 72, 73, 74 ,75 ,76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 97, 98, 99, 100, 101, 102, 107
];
